export const API_URL = "https://stage.easypointapi.com/api/"